export const reports = {
    // Títulos de header do Stack (app/reports/_layout.tsx).
    screens: {
        index: 'Relatórios',
        custom: 'Relatório',
        advanced: 'Relatórios avançados',
        analysis: 'Análise',
        categoryNet: 'Resultado por categoria',
        compare: 'Comparar períodos',
        weekday: 'Por dia da semana',
        fixedVariable: 'Fixas × variáveis',
        cashFlow: 'Fluxo de caixa',
        budgetVsActual: 'Previsto × realizado',
        export: 'Exportar para planilha',
        invoices: 'Relatório de faturas',
    },

    // Toasts de erro de exportação, reusados por quase todas as telas.
    errors: {
        export: 'Erro ao exportar',
        exportFailed: 'Falha ao exportar',
    },

    // ReportPeriodSelector (compartilhado por todas as telas de relatório) + o
    // helper getReportPeriodRange (fora de componente → i18n.t no momento do uso).
    period: {
        month: 'Mês',
        year: 'Ano',
        custom: 'Personalizado',
        until: 'até',
        customRangeLabel: '{{start}} a {{end}}',
        status: 'Situação',
        statusAll: 'Todas',
        statusSettled: 'Concluídas',
        statusPending: 'Pendentes',
        // Legendas do ReportStatusMenu: "Todas" e "Concluídas" mudam o número da manchete,
        // e sem isto a diferença entre elas só aparece depois de escolher.
        statusAllHint: 'Concluídas + previstas',
        statusSettledHint: 'Só o que já se efetivou',
        statusPendingHint: 'Só o que falta acontecer',
    },

    // ReportPdfButton.
    pdfButton: {
        exportPdf: 'Exportar PDF',
    },

    // Menu app/reports/advanced.tsx (constante REPORTS → função getReports(t)).
    teaser: {
        badge: 'PRO',
        cta: 'Desbloquear com o Pro',
        dismiss: 'Agora não',
        invoicesTitle: 'Sua fatura, aberta por cartão, tag e categoria',
        invoicesSubtitle: 'O relatório já está pronto com os seus lançamentos. Desbloqueie pra ver os valores.',
        cashFlowTitle: 'Pra onde seu caixa vai até o fim do período',
        cashFlowSubtitle: 'Entradas, saídas e o acumulado mês a mês, com os seus números de verdade.',
        categoryNetTitle: 'O que cada categoria deixa no seu bolso',
        categoryNetSubtitle: 'Entradas e saídas por categoria, com o resultado líquido de cada uma.',
        compareTitle: 'Este período contra o anterior, lado a lado',
        compareSubtitle: 'Receitas, gastos e o que mudou entre os dois períodos.',
        weekdayTitle: 'Em que dia da semana seu dinheiro vai embora',
        weekdaySubtitle: 'Seus gastos somados por dia da semana, no período que você escolher.',
        fixedVariableTitle: 'Quanto do seu gasto é fixo e quanto é escolha',
        fixedVariableSubtitle: 'Fixas e variáveis separadas, com a fatia de cada uma.',
        budgetVsActualTitle: 'Orçado contra realizado, mês a mês',
        budgetVsActualSubtitle: 'Quanto você planejou, quanto gastou e quanto sobrou em cada orçamento.',
        exportTitle: 'Seus lançamentos em planilha',
        exportSubtitle: 'CSV pronto pra Excel e Google Sheets, com resumo mensal por conta.',
    },
    advanced: {
        categoryNet: {
            title: 'Resultado por categoria',
            subtitle: 'Entradas, saídas e saldo por período',
        },
        compare: {
            title: 'Comparar períodos',
            subtitle: 'Mês, ano ou intervalo personalizado',
        },
        weekday: {
            title: 'Despesas por dia da semana',
            subtitle: 'Em que dias você mais gasta no período',
        },
        fixedVariable: {
            title: 'Fixas × variáveis',
            subtitle: 'Recorrentes vs gastos avulsos por período',
        },
        cashFlow: {
            title: 'Fluxo de caixa',
            subtitle: 'Entradas, saídas e saldo acumulado mês a mês',
        },
        budgetVsActual: {
            title: 'Previsto × realizado',
            subtitle: 'Orçado vs gasto, mês a mês',
        },
        export: {
            title: 'Exportar para planilha',
            subtitle: 'Resumo mensal por conta ou todas as transações (CSV)',
        },
        invoices: {
            title: 'Relatório de faturas',
            subtitle: 'Total por tag, cartão ou categoria nas faturas do mês',
        },
    },

    // app/reports/invoices.tsx
    invoices: {
        cardsLabel: 'Cartões',
        categoriesLabel: 'Categorias',
        tagsLabel: 'Tags',
        allCards: 'Todos os cartões',
        allCategories: 'Todas as categorias',
        allTags: 'Todas as tags',
        noCategories: 'Nenhuma categoria nas faturas deste mês.',
        cardsSheetTitle: 'Filtrar por cartão',
        cardsSheetSubtitle: 'Escolha um ou mais. Sem seleção, mostramos todos.',
        cardsSearchPlaceholder: 'Buscar cartão...',
        groupByLabel: 'Agrupar por',
        totalFiltered: 'Total filtrado',
        filterCardsMulti: '{{n}} cartões',
        filterCategoriesMulti: '{{n}} categorias',
        filterTagsMulti: '{{n}} tags',
        byTag: 'Tags',
        byCard: 'Cartões',
        byCategory: 'Categorias',
        totalLabel: 'Total das faturas',
        itemsLabel: 'Itens',
        untagged: 'Sem tag',
        uncategorized: 'Sem categoria',
        itemCount_one: '{{count}} item',
        itemCount_other: '{{count}} itens',
        empty: 'Nenhuma fatura com lançamentos neste mês para os cartões escolhidos.',
        noCards: 'Nenhum cartão cadastrado. Crie um cartão de crédito para usar este relatório.',
        pdfTitle: 'Relatório de faturas',
        pdfColGroup: 'Grupo',
        pdfColItems: 'Itens',
        pdfColAmount: 'Valor',
        exportPdf: 'Exportar PDF',
    },

    // app/reports/category-net.tsx
    categoryNet: {
        pdfTitle: 'Resultado por categoria',
        income: 'Entradas',
        expense: 'Saídas',
        result: 'Resultado',
        categoriesSection: 'Categorias',
        colCategory: 'Categoria',
        empty: 'Sem lançamentos neste período.',
        rowInflow: 'entra {{amount}}',
        rowOutflow: 'sai {{amount}}',
    },

    // app/reports/compare.tsx
    compare: {
        pdfTitle: 'Comparar períodos',
        vs: '{{a}} vs {{b}}',
        variation: 'Variação',
        summarySection: 'Resumo',
        indicator: 'Indicador',
        category: 'Categoria',
        byCategory: 'Despesas por categoria',
        categoryEmpty: 'Sem despesas para comparar neste período.',
        rows: {
            inflow: 'Entradas',
            outflow: 'Saídas',
            result: 'Resultado',
        },
        delta: {
            noChange: 'Sem mudança',
        },
    },

    // app/reports/weekday.tsx
    weekday: {
        pdfTitle: 'Despesas por dia da semana',
        totalInPeriod: 'Total no período',
        totalInPeriodLine: 'Total no período: {{amount}}',
        daysSection: 'Dias da semana',
        colDay: 'Dia',
        colValue: 'Valor',
        colPctOfMax: '% do maior dia',
        pct: '{{pct}}%',
        days: {
            sunday: 'Domingo',
            monday: 'Segunda',
            tuesday: 'Terça',
            wednesday: 'Quarta',
            thursday: 'Quinta',
            friday: 'Sexta',
            saturday: 'Sábado',
        },
    },

    // app/reports/fixed-variable.tsx. O título do PDF usa "x" minúsculo
    // (literal da tela de hoje), diferente do "×" dos headers/menu.
    fixedVariable: {
        pdfTitle: 'Fixas x variáveis',
        total: 'Total',
        fixed: 'Fixas',
        fixedSub: 'Recorrentes e assinaturas',
        variable: 'Variáveis',
        variableSub: 'Gastos avulsos',
        expensesSection: 'Despesas',
        colType: 'Tipo',
        colDescription: 'Descrição',
        colValue: 'Valor',
        colPct: '%',
        pct: '{{pct}}%',
    },

    // app/reports/cash-flow.tsx
    cashFlow: {
        pdfTitle: 'Fluxo de caixa',
        pdfSubtitle: '{{range}} · realizado (confirmadas)',
        income: 'Entradas',
        expense: 'Saídas',
        net: 'Líquido',
        openNoSettle: 'Ainda por acontecer',
        monthSection: 'Mês a mês',
        colMonth: 'Mês',
        colIncome: 'Entradas',
        colExpense: 'Saídas',
        colNet: 'Líquido',
        colCumulative: 'Acumulado',
        colOpen: 'Em aberto',
        legendNet: 'Líquido do mês',
        legendCumulative: 'Acumulado',
        // Card "Ainda por acontecer" do PDF: valor = toPay + este sufixo quando há a receber.
        pendingSummaryReceiveSuffix: ' · {{amount}} a receber',
        pendingNote: 'Pendentes não contam no realizado acima.',
        realizedSoFar: 'Realizado até agora',
        realizedSoFarLine: 'Realizado até agora: {{amount}}',
        noteProjected: 'Visão de caixa com previstos: soma o que ainda não foi pago e as recorrências que vencem no período. Compras no cartão entram pelo vencimento da fatura.',
        monthFlow: 'Entrou {{income}} · Saiu {{expense}}',
        monthOpen: 'Em aberto: {{parts}}',
        toPay: '{{amount}} a pagar',
        toReceive: '{{amount}} a receber',
        cumulativeShort: 'acum. {{amount}}',
        note: 'Visão de caixa: só confirmadas contam no realizado; compras no cartão entram quando a fatura é paga. Lançamentos sem baixa aparecem como em aberto.',

        // Cabeçalho escuro: a manchete é o acumulado do FIM do período — "eu chego no
        // positivo?". O texto muda com a Situação e com o modo de período.
        hero: {
            endsWith: {
                month: 'Se nada mudar, você termina o mês com',
                year: 'Se nada mudar, você termina o ano com',
                custom: 'Se nada mudar, você termina o período com',
            },
            settledLabel: 'Realizado até agora',
            pendingLabel: 'O que ainda falta acontecer',
            deltaFromToday: '{{amount}} do que tem hoje',
            today: 'hoje',
            chipProjected: 'Com previstos',
            chipSettled: 'Só concluídas',
            chipPending: 'Só pendentes',
        },

        // Card do mês que mais tira do caixa. O motivo nomeia as maiores saídas do mês;
        // sem categorias (mês só com previsto de recorrência) cai no texto genérico.
        critical: {
            title: '{{month}} é o mês que mais tira',
            // Com Início do mês ≠ 1 (ADR 0190) o usuário vê o intervalo, nunca o nome do mês.
            titlePeriod: '{{range}} é o que mais tira',
            subtitle: '{{amount}} · {{reason}}',
            reasonPair: '{{first}} e {{second}} caem juntos',
            reasonSingle: '{{first}} puxa o mês',
            reasonPlain: 'maior saldo negativo do período',
        },

        // Gráfico espelhado do mês a mês (saiu à esquerda, entrou à direita).
        months: {
            title: 'O que cada mês faz com o caixa',
            legendProjected: 'previsto',
            legendUnit: 'valores em {{symbol}}',
            colOut: 'saiu',
            colIn: 'entrou',
            colNet: 'líquido',
            totalIn: 'Entrou',
            totalOut: 'Saiu',
        },

        // Linha de pendências ("Ainda por acontecer: X a pagar e Y a receber. Contados na
        // curva."). Um número só em qualquer Situação (D3, 1.0.63); só o sufixo muda.
        open: {
            prefix: 'Ainda por acontecer:',
            join: ' e ',
            counted: 'Contados na curva.',
            notCounted: 'Fora desta visão.',
        },
    },

    // app/reports/budget-vs-actual.tsx
    budgetVsActual: {
        pdfTitle: 'Previsto × realizado',
        budgeted: 'Previsto',
        spent: 'Realizado',
        diff: 'Diferença',
        period: 'Período',
        leftover: 'Sobram {{amount}}',
        over: 'Estourou {{amount}}',
        spentOfBudgeted: '{{spent}} de {{budgeted}}',
        monthProgress: '{{spent}} de {{budgeted}} · {{pct}}%',
        // Sufixo literal concatenado ao mês formatado (date-fns) quando o mês é
        // parcial; mantido como sufixo pra não reestruturar a formatação de data.
        partialSuffix: ' (parcial)',
        monthSection: 'Mês a mês',
        colMonth: 'Mês',
        colBudgeted: 'Previsto',
        colSpent: 'Realizado',
        colDiff: 'Diferença',
        colPct: '%',
        pct: '{{pct}}%',
        budgetsSection: 'Orçamentos no período',
        colBudget: 'Orçamento',
        budgetsEmpty: 'Nenhum orçamento ativo.',
        budgetFallbackName: 'Orçamento',
        emptyTitle: 'Sem orçamentos por enquanto',
        emptyBody: 'O previsto vem dos seus orçamentos. Crie um em Mais › Orçamento e volte aqui pra comparar com o realizado.',
        note: 'O previsto usa os tetos atuais dos orçamentos, um teto por ciclo que cai no mês (4 ou 5 semanas, 2 quinzenas; períodos parciais contam a fração do mês). O realizado segue o ciclo de cada orçamento. Mudanças no orçamento valem também pros meses passados.',
    },

    // app/reports/export.tsx
    export: {
        period: 'Período',
        pdfTitle: 'Relatório PDF do período',
        pdfSubtitle: 'Resumo financeiro com contas, categorias, meses e transações.',
        sheetTitle: 'Planilha mensal por conta',
        sheetSubtitle: 'Receitas e despesas por conta. Usa os meses cobertos pelo período selecionado.',
        transactionsTitle: 'Todas as transações',
        transactionsSubtitle: 'Uma linha por transação, com descrição, categoria, conta e cartão.',
        pdfReady: 'PDF pronto',
        pdfDocTitle: 'Relatório financeiro {{range}}',
        sheetReady: 'Planilha pronta',
        // {{rowCount}} em vez de {{count}}: número literal, "origens" é fixo (sem plural).
        sheetReadyBody: '{{rowCount}} origens preparadas para compartilhamento local.',
        csvReady: 'CSV pronto',
        csvReadyBody: '{{rowCount}} transações preparadas para compartilhamento local.',
        note: 'CSVs usam separador “;” no padrão pt-BR e abrem direto no Excel ou Google Sheets. O PDF usa o mesmo compartilhamento local. Nada sai do aparelho sem você escolher onde compartilhar.',
    },

    // app/reports/custom.tsx
    custom: {
        clear: 'Limpar',
        period: 'Período',
        type: 'Tipo',
        account: 'Conta',
        accounts: 'Contas',
        allAccounts: 'Todas as contas',
        tags: 'Tags',
        allTags: 'Todas as tags',
        categories: 'Categorias',
        allCategories: 'Todas as categorias',
        groupBy: 'Agrupar por',
        groupByNone: 'Sem agrupamento',
        groupByHint: 'Escolha as quebras que o relatório vai desenhar.',
        generate: 'Gerar relatório',
        accountSelectorTitle: 'Filtrar por conta',
        // ReportCategoriesSheet (multi-seleção de categorias do relatório).
        categoriesModalTitle: 'Filtrar por categoria',
        categorySearchPlaceholder: 'Buscar categoria',
        noCategoryFound: 'Nenhuma categoria encontrada',
        // TYPE_OPTIONS (constante → função typeOptions(t)).
        typeExpense: 'Despesas',
        typeIncome: 'Receitas',
        typeAll: 'Todas',
        // GROUP_BY_ORDER → rótulo por chave (t(`custom.group.${group}`)).
        group: {
            category: 'Categoria',
            tag: 'Tag',
            account: 'Conta',
            month: 'Mês',
        },
        // Resumo das linhas de filtro quando há mais de um selecionado. Números
        // literais (sem plural) → placeholders próprios.
        accountsSelected: '{{accountCount}} contas',
        categoriesSelected: '{{catCount}} categorias',
        tagsSelected: '{{tagCount}} tags',
        // Título do relatório exportado (PDF/CSV).
        title: {
            expense: 'Despesas',
            income: 'Receitas',
            all: 'Financeiro',
            accountsCount: '{{accountCount}} contas',
            tagsCount: '{{tagCount}} tags',
            categoriesCount: '{{catCount}} categorias',
            report: 'Relatório {{parts}}',
        },
        summary: {
            totalExpense: 'Total despesas',
            expense: 'Despesas',
            totalIncome: 'Total receitas',
            income: 'Receitas',
            balance: 'Saldo',
        },
        byAccount: 'Por conta',
        byTag: 'Por tag',
        byCategory: 'Por categoria',
        // "transações" é fixo hoje (não pluraliza com 1) → {{txCount}}, não {{count}}.
        transactionsCount: '{{txCount}} transações',
        subcategoriesOf: 'Subcategorias de {{name}}',
        total: 'Total',
        moreCount: '+{{n}} mais',
        monthlySummary: 'Resumo mensal',
        monthCol: 'Mês',
        incomeCol: 'Receitas',
        expenseCol: 'Despesas',
        balanceCol: 'Saldo',
        totalCol: 'Total',
        transactionsTitle: 'Transações ({{txCount}})',
        noCategory: 'Sem categoria',
        moreTransactions: '... e mais {{remaining}} transações',
        empty: 'Nenhuma transação encontrada para os filtros selecionados.',
        exportPdf: 'Exportar PDF',
        exportCsv: 'Exportar CSV',
        exportTitle: 'Exportar relatório',
        exportMessage: 'Escolha o formato do arquivo que vai ser compartilhado.',
        exportPdfDescription: 'Documento pronto pra ler, imprimir ou enviar.',
        exportCsvDescription: 'Planilha pra abrir no Excel ou no Google Sheets.',
    },

    // components/charts/ExpensePieChart.tsx
    pie: {
        defaultTitle: 'Despesas por categoria',
        total: 'Total',
        topCategory: 'Maior categoria',
        noCategory: 'Sem categoria',
        share: 'Participação',
        ofMonthTotal: 'do total do mês',
        topWeight: 'Categorias com maior peso',
        others: 'Outros',
        othersGrouped: '+{{n}} agrupadas em outros',
        categoryCount_one: '{{count}} categoria no período',
        categoryCount_other: '{{count}} categorias no período',
        expandSubcategories: 'Ver subcategorias',
        collapseSubcategories: 'Recolher subcategorias',
        subPctOfCategory: '{{pct}}% da categoria',
        pct: '{{pct}}%',
    },

    // Texto gerado no HTML do PDF (lib/reportTemplates.ts, lib/reportService.ts) e
    // no conteúdo das planilhas/CSV (lib/reportExport.ts, lib/reportService.ts).
    // Fora de componente → i18n.t no momento da geração. Nomes de conta/categoria/
    // tag são dados do usuário e NÃO entram aqui (só rótulos e cabeçalhos).
    pdf: {
        // Cabeçalho e cards de resumo do PDF (reportTemplates).
        headerSubtitle: '{{start}} a {{end}} · {{count}} transações',
        totalExpenses: 'Total de Despesas',
        totalIncome: 'Total de Receitas',
        income: 'Receitas',
        expenses: 'Despesas',
        balance: 'Saldo',
        // Títulos de seção do PDF.
        byAccount: 'Por Conta',
        byTag: 'Por Tag',
        categories: 'Categorias',
        subcategoriesOf: 'Subcategorias de {{category}}',
        monthlySummary: 'Resumo Mensal',
        transactionsTitle: 'Transações ({{count}})',
        // Cabeçalhos de coluna (reusados por PDF e CSV).
        colAccount: 'Conta',
        colTag: 'Tag',
        colCount: 'Qtd',
        colSubcategory: 'Subcategoria',
        colCategory: 'Categoria',
        colValue: 'Valor',
        colMonth: 'Mês',
        colDate: 'Data',
        colDescription: 'Descrição',
        colTime: 'Hora',
        colType: 'Tipo',
        colCard: 'Cartão',
        colNotes: 'Observações',
        colTags: 'Tags',
        // Rodapé e mensagens do PDF.
        moreTransactions: '... e mais {{count}} transações não listadas',
        generatedAt: 'Gerado em {{datetime}}',
        noData: 'Sem dados neste período.',
        // Planilha mensal por conta (reportExport) — rótulos visíveis no CSV.
        cardStatement: 'Fatura Cartão {{name}}',
        noAccount: 'Sem conta',
        accountOrigin: 'Conta / Origem',
        total: 'Total',
        incomeSection: 'RECEITAS',
        expenseSection: 'DESPESAS',
        totalIncomeRow: 'Total de receitas',
        totalExpensesRow: 'Total de despesas',
        monthBalance: 'Saldo do mês',
        cumulativeBalance: 'Saldo acumulado',
        // Rótulos de tipo de transação no CSV.
        txTypeIncome: 'Receita',
        txTypeExpense: 'Despesa',
        txTypeTransfer: 'Transferência',
        txTypeAdjustment: 'Ajuste',
    },
};
